<app-navbar-control></app-navbar-control>

<div class="features-details">

    <section class="hero-section">

        <div class="container">

            <div class="hero-content text-center">

                <span class="section-badge">
                    {{ 'featuresHero.badge' | translate }}
                </span>

                <h1 class="hero-title">
                    {{ 'featuresHero.title1' | translate }}
                    <span>{{ 'featuresHero.title2' | translate }}</span>
                    {{ 'featuresHero.title3' | translate }}
                </h1>

                <p class="hero-subtitle">
                    {{ 'featuresHero.subtitle' | translate }}
                </p>

                <div class="hero-actions">

                    <a [routerLink]="['../auth/create-account']" class="btn btn-primary-custom">
                        {{ 'featuresHero.startFree' | translate }}
                    </a>

                    <a [routerLink]="['/pricing']" class="btn btn-outline-custom">
                        {{ 'featuresHero.viewPricing' | translate }}
                    </a>

                </div>

                <div class="hero-feature-panel">

                    <div class="hero-feature-item">
                        <i class="fas fa-calendar-check"></i>
                        <span>{{ 'featuresHero.onlineBooking' | translate }}</span>
                    </div>

                    <div class="hero-feature-item">
                        <i class="fas fa-users"></i>
                        <span>{{ 'featuresHero.teamScheduling' | translate }}</span>
                    </div>

                    <div class="hero-feature-item">
                        <i class="fas fa-user-friends"></i>
                        <span>{{ 'featuresHero.clientManagement' | translate }}</span>
                    </div>

                    <div class="hero-feature-item">
                        <i class="fas fa-bell"></i>
                        <span>{{ 'featuresHero.automatedReminders' | translate }}</span>
                    </div>

                    <div class="hero-feature-item">
                        <i class="fas fa-credit-card"></i>
                        <span>{{ 'featuresHero.payments' | translate }}</span>
                    </div>

                    <div class="hero-feature-item">
                        <i class="fas fa-robot"></i>
                        <span>{{ 'featuresHero.automation' | translate }}</span>
                    </div>

                    <div class="hero-feature-item">
                        <i class="fas fa-chart-line"></i>
                        <span>{{ 'featuresHero.analytics' | translate }}</span>
                    </div>

                    <div class="hero-feature-item">
                        <i class="fas fa-globe"></i>
                        <span>{{ 'featuresHero.multiLocation' | translate }}</span>
                    </div>

                    <div class="hero-feature-item">
                        <i class="fas fa-shield-alt"></i>
                        <span>{{ 'featuresHero.enterpriseSecurity' | translate }}</span>
                    </div>

                </div>

            </div>

        </div>

    </section>

    <section class="feature-section">

        <div class="container">
            @for (feature of featureSections; track feature; let i = $index) {
            <div class="feature-block">

                <div class="row align-items-center g-5">

                    <div class="col-lg-5">

                        <div class="feature-content">

                            <span class="section-badge">
                                {{ feature.badge }}
                            </span>

                            <h2 class="section-title">
                                {{ feature.heading }}
                            </h2>

                            <p class="section-subtitle">
                                {{ feature.description }}
                            </p>

                        </div>

                    </div>

                    <div class="col-lg-7">

                        <div class="feature-card">

                            <div class="feature-card-header">

                                <div class="feature-icon">
                                    <i class="fas {{ feature.icon }}"></i>
                                </div>

                                <div>
                                    <h4>{{ feature.title }}</h4>
                                    <p>
                                        Explore the capabilities available within
                                        this module.
                                    </p>
                                </div>

                            </div>

                            <div class="feature-grid">

                                @for(section of feature.sections; track section) {

                                <div class="feature-item">

                                    <div class="feature-check">
                                        <i class="fas fa-check"></i>
                                    </div>

                                    <span>
                                        {{ section }}
                                    </span>

                                </div>

                                }

                            </div>

                        </div>

                    </div>

                </div>

            </div>
            }
        </div>
    </section>
    <app-footer></app-footer>
</div>